import i18n from '../../i18n';

export const ciConfig = {
  get labels() {
    return {
      part_ir: i18n.t('countryLabels.ci.partIr'),
      trimf: i18n.t('countryLabels.ci.trimf'),
    };
  },
  currency: "FCFA",
  taxSystem: "ci",
  allowedReports: [
    "Livre de paie",
    "Charges salariales",
    "Charges patronales",
    "FDFP",
    "DISA",
    "ITS",
    // Correspond a excoci_cotisations : le filtre teste aussi report_name.
    "Cotisations",
  ]
};